var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstallBtnCrm = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H3c-1.654 0-3-1.346-3-3v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 .551.449 1 1 1h18c.551 0 1-.449 1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 1.654-1.346 3-3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 12.707l-4 4c-.391.391-1.023.391-1.414 0l-4-4c-.286-.286-.372-.716-.217-1.09.155-.373.52-.617.924-.617h3V1c0-.552.448-1 1-1s1 .448 1 1v10h3c.404 0 .769.244.924.617.155.374.069.804-.217 1.09z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstallBtnCrm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/installBtnCRM.b49bd925.svg";
export { ForwardRef as ReactComponent };